import { AbstractControl, ValidationErrors, Validators, ValidatorFn } from '@angular/forms';
import isEmpty from 'lodash.isempty';
import memoize from 'lodash.memoize';

import { POSTAL_CODE_VALIDATION_RULES } from '~shared/constants/validation-rules.constant';

const postalCodeValidator = memoize(createValidator);

export function postalCodeFormValidator (control: AbstractControl): ValidationErrors | null {
  const countryField = control.get('country');
  const postalCodeField = control.get('postalCode');

  if (!countryField || !postalCodeField) {
    return null;
  }

  const errors = {
    ...postalCodeField.errors,
    ...postalCodeValidator(countryField.value)(postalCodeField),
  };

  postalCodeField.setErrors(isEmpty(errors) ? null :  errors);

  return null;
}

export function generateValidatorFunction(validators: ValidatorFn[], countryCode: string): ValidatorFn{
  return function(control: AbstractControl): ValidationErrors | null {
    const errors = validators.reduce((err, validator) => ({
      ...err,
      ...validator(control),
    }), {});

    return addCountryToErrorKey(errors, countryCode);
  };
}

function createValidator(countryCode: string): ValidatorFn {
  const {
    pattern,
    minLength = 0,
    maxLength,
  } = POSTAL_CODE_VALIDATION_RULES[countryCode] || POSTAL_CODE_VALIDATION_RULES;
  const validators = [
    Validators.pattern(pattern),
    Validators.minLength(minLength),
    Validators.maxLength(maxLength),
  ];

  return generateValidatorFunction(validators, countryCode);
}

function addCountryToErrorKey(errors, countryCode) {
  const useCountryRules = Boolean(POSTAL_CODE_VALIDATION_RULES[countryCode]);

  if (!useCountryRules) {
    return errors;
  }

  return Object.keys(errors).reduce((modifiedErrors, errorKey) => ({
    ...modifiedErrors,
    [`${errorKey}_${countryCode}`]: errors[errorKey],
  }), {});
}
